module.exports = __webpack_public_path__ + "static/feature-right-img-e637abce9b291c6f497020f53d677036.png";